class StoreImages {
  #images = [];

  #pageBuilderID = null;

  #handlers = {
    toggleModal: () => {},
    onSelect: () => {}
  };

  get images() {
    return [...this.#images];
  }

  resetImages() {
    this.#images = [];
  }

  setHandlers({ toggleModal, setSelectedImage }) {
    if (typeof toggleModal === 'function') this.#handlers.toggleModal = toggleModal;
    if (typeof setSelectedImage === 'function') this.#handlers.onSelect = setSelectedImage;
  }

  addImages(newImages, { pageBuilderID } = {}, handlers = {}) {
    if (!Array.isArray(newImages) || newImages.length === 0) {
      return this.images;
    }

    if (pageBuilderID != null && pageBuilderID !== this.#pageBuilderID) {
      this.resetImages();
      this.#pageBuilderID = pageBuilderID;
    }

    const merged = this.#images.concat(newImages);
    this.#images = Array.from(new Map(merged.map(img => [img.imageId, img])).values());

    this.setHandlers(handlers);
    return this.images;
  }

  toggleModal = () => {
    this.#handlers.toggleModal();
  };

  handleSelectedImage = imageId => {
    const idx = this.#images.findIndex(img => img.imageId === imageId);
    if (idx !== -1) this.#handlers.onSelect(idx);
  };
}

export default new StoreImages();
